import Vue from "vue";
import Router from "vue-router";
import AppLayout from "../components/admin/AppLayout";
import AppLayoutAluno from "../components/admin/AppLayoutAluno";
import AppLayoutInstrutor from "../components/admin/AppLayoutInstrutor";
import AppLayoutSupport from "../components/admin/AppLayoutSupport";
import AppLayoutFinanceiro from "../components/admin/AppLayoutFinanceiro";
import AppLayoutComercial from "../components/admin/AppLayoutComercial";
import AppLayoutMonitoramento from "../components/admin/AppLayoutMonitoramento";
import AppLayoutDetran from "../components/admin/AppLayoutDetran";
import AppLayoutEad from "../components/admin/AppLayoutEad";
import AppLayoutComissao from "../components/admin/AppLayoutComissao";
import AuthLayout from "../components/auth/AuthLayout";
import lazyLoading from "./lazyLoading";
import OpenLayout from "../layouts/OpenLayout.vue";
import PrivacyPolicy from "../pages/PrivacyPolicy.vue";

Vue.use(Router);

const demoRoutes = [];
if (process.env.NODE_ENV === "development") {
    const VueBook = require("vue-book").default;

    demoRoutes.push(
        VueBook(require.context("./..", true, /.demo.vue$/), "/demo"),
        VueBook(
            require.context("./../components", true, /.vue$/),
            "/presentation"
        )
    );
}

const EmptyParentComponent = {
    template: "<router-view></router-view>",
};

const router = new Router({
    mode: "history",
    routes: [
        /* {
           name: 'PortalAluno',
           path: '/candidato/aulas/:status?',
           component: lazyLoading('admin/AppLayoutAluno'),
         },*/
        {
            name: "OKRoute",
            path: "/health",
            component: {
                render: (h) => h("div", "ok"),
            },
        },
        {
            path: "/frame-redirect",
            name: "PaginaComXFrameOptions",
            component: lazyLoading("ead/iframeRedirect"),
            meta: {
                // Defina os metadados para esta rota
                xFrameOptions: "SAMEORIGIN", // Defina o valor do cabeçalho X-Frame-Options
            },
        },
        {
            name: "Suporte",
            path: "/suporte",
            component: AppLayoutSupport,
            beforeEnter: (to, from, next) => {
                if (localStorage.id_role !== "7") {
                    next({ name: "login" });
                } else {
                    next();
                }
            },
            children: [
                {
                    name: "EnvioAulasPraticas",
                    path: "/suporte/envios-praticas",
                    component: lazyLoading("praticas/EnvioAulas/EnvioAulas"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "EnvioAulasPraticas_teste",
                    path: "/suporte/envios-praticas-teste",
                    component: lazyLoading(
                        "praticas/EnvioAulas/EnvioAulas_copy"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
            ],
        },
        {
            name: "Dashboard",
            path: "/aulas/:dataI?/:dataF?",
            component: lazyLoading("dashboard-relatorios/DashboardRelatorios"),
        },
        {
            name: "RelatorioContestacaoAulaRealizada",
            path: "/monitoramento/relatorio-contestacao-aula-realizada/:autoescola/:aula",
            component: lazyLoading(
                "relatorios/RelatorioContestacaoAulaRealizada"
            ),
            beforeEnter: (to, from, next) => {
                if (
                    localStorage.id_role !== "2" &&
                    localStorage.id_role !== "9"
                ) {
                    next({ name: "login" });
                } else {
                    next();
                }
            },
        },
        {
            path: "*",
            redirect: { name: "not-found-large-text" },
        },
        {
            path: "/",
            component: AuthLayout,
            children: [
                {
                    name: "login",
                    path: "/:autoescola?",
                    component: lazyLoading("auth/login/Login"),
                },
                {
                    name: "loginAluno",
                    path: "aluno/:autoescola?",
                    component: lazyLoading("auth/login/LoginAluno"),
                },
                {
                    name: "loginInstrutor",
                    path: "instrutor/:autoescola?",
                    component: lazyLoading("auth/login/LoginInstrutor"),
                },
                {
                    name: "login-sessao-ativa",
                    path: "sessao-ativa",
                    component: lazyLoading("auth/login/LoginSessaoAtiva"),
                },
                {
                    name: "redefinir-senha",
                    path: "redefinir-senha",
                    component: lazyLoading("auth/senha/RedefinirSenha"),
                },
                {
                    name: "nova-senha",
                    path: "nova-senha/:token",
                    component: lazyLoading("auth/senha/NovaSenha"),
                },
                {
                    name: "nova-senha-expirado",
                    path: "nova-senha/link-expirado/:token",
                    component: lazyLoading("auth/senha/NovaSenhaLinkExpirado"),
                },
            ],
        },
        {
            path: "/sobre",
            component: OpenLayout,
            children: [
                {
                    name: "privacidade",
                    path: "privacidade",
                    component: PrivacyPolicy,
                },
            ],
        },
        {
            path: "/404",
            component: EmptyParentComponent,
            children: [
                {
                    name: "not-found-advanced",
                    path: "not-found-advanced",
                    component: lazyLoading(
                        "pages/404-pages/VuesticPageNotFoundSearch"
                    ),
                },
                {
                    name: "not-found-simple",
                    path: "not-found-simple",
                    component: lazyLoading(
                        "pages/404-pages/VuesticPageNotFoundSimple"
                    ),
                },
                {
                    name: "not-found-custom",
                    path: "not-found-custom",
                    component: lazyLoading(
                        "pages/404-pages/VuesticPageNotFoundCustom"
                    ),
                },
                {
                    name: "not-found-large-text",
                    path: "",
                    component: lazyLoading(
                        "pages/404-pages/VuesticPageNotFoundLargeText"
                    ),
                },
            ],
        },
        {
            name: "Instrutor",
            path: "/instrutor-cfc/",
            component: AppLayoutInstrutor,
            children: [
                {
                    name: "aulasInstrutor",
                    path: "aulas/:status?",
                    component: lazyLoading("ead/aulasIntrutor"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
            ],
        },
        {
            name: "Candidato",
            path: "/candidato/",
            component: AppLayoutAluno,
            beforeEnter: (to, from, next) => {
                if (localStorage.id_role !== "4") {
                    if (localStorage.id_role === "3") {
                        next({ name: "listagem-turmas" });
                    } else {
                        next()({ name: "loginAluno" });
                    }
                }
                next();
            },
            children: [
                {
                    name: "aulas-teoricas",
                    path: "aulas-teoricas/:status?",
                    component: lazyLoading("ead/eadAluno"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "aulas-praticas",
                    path: "aulas-praticas/:status?",
                    component: lazyLoading("ead/praticasAluno"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "aluno",
                    path: "aluno/perfil/",
                    component: lazyLoading("ead/eadPerfilAluno"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
            ],
        },
        {
            name: "Financeiro",
            path: "/financeiro/",
            component: AppLayoutFinanceiro,
            beforeEnter: (to, from, next) => {
                if (localStorage.id_role !== "6") {
                    router.push({ name: "login" });
                } else {
                    next();
                }
            },
            children: [
                {
                    name: "index",
                    path: "faturas",
                    component: lazyLoading("financeiro/Index"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                    children: [
                        {
                            name: "faturas_boletos",
                            path: "faturamento-autoescola",
                            props: true,
                            component: lazyLoading(
                                "financeiro/components/FaturasBoletos"
                            ),
                        },
                        {
                            name: "transactions_financeiro",
                            path: "transacoes",
                            props: true,
                            component: lazyLoading(
                                "credito/Transactions"
                            ),
                        },
                        {
                            name: "Listar_alunos",
                            path: "alunos-faturados",
                            props: true,
                            component: lazyLoading("monitoria/alunos/Alunos"),
                        },
                        {
                            name: "faturas_cadastradas",
                            path: "alunos-cadastrados",
                            props: true,
                            component: lazyLoading(
                                "financeiro/components/FaturasCadastradas"
                            ),
                        },
                        {
                            name: "relatorios",
                            path: "relatorios",
                            props: true,
                            component: lazyLoading(
                                "financeiro/components/Relatorio"
                            ),
                        },
                        {
                            name: "faturamento-panel",
                            path: "painel-faturamento",
                            props: true,
                            component: lazyLoading(
                                "financeiro/FaturamentoPanel"
                            ),
                        },
                        {
                            name: "importarFaturas-financeiro",
                            path: "importar",
                            component: lazyLoading(
                                "faturas/import-faturas/ImportFaturas"
                            ),
                        },
                        {
                            name: "autoescolas",
                            path: "autoescolas",
                            props: true,
                            component: lazyLoading("comercial/Index"),
                        },
                        {
                            name: "sindicato-recebimentos",
                            path: "sindicato/recebimentos",
                            props: true,
                            component: lazyLoading(
                                "financeiro/components/SindicatoRecebimento"
                            ),
                        },
                        {
                            name: "historico-baixa-manual",
                            path: "historico-baixa-manual",
                            props: true,
                            component: lazyLoading(
                                "financeiro/baixa-manual/HistoricoBaixaManual"
                            ),
                        },
                    ],
                },
                {
                    name: "produtos-servicos",
                    path: "produtos-servicos",
                    props: true,
                    component: lazyLoading(
                        "financeiro/ProdutosServicos"
                    ),
                },
                {
                    name: "criar-cobranca",
                    path: "criar-cobranca",
                    props: true,
                    component: lazyLoading(
                        "financeiro/NovaCobranca"
                    ),
                },
                {
                    name: "buscar-cobranca",
                    path: "buscar-cobranca",
                    props: true,
                    component: lazyLoading(
                        "financeiro/BuscarCobrancas"
                    ),
                },
                {
                    name: "creditos",
                    path: "creditos",
                    props: true,
                    component: lazyLoading(
                        "credito/Index"
                    ),
                },
            ],
        },
        {
            name: "Comissao",
            path: "/comissao/",
            component: AppLayoutComissao,
            beforeEnter: (to, from, next) => {
                if (localStorage.id_role !== "1") {
                    //Uma função há de ser criada em algum momento, mudar a role pra o numero correto
                    next({ name: "login" });
                } else {
                    next();
                }
            },
            children: [
                {
                    name: "relatorio-consultor",
                    path: "relatorio-consultor",
                    component: lazyLoading(
                        "relatorios/modal/administrativo/ComissaoConsultor"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
            ],
        },
        {
            name: "Comercial",
            path: "/comercial/",
            component: AppLayoutComercial,
            beforeEnter: (to, from, next) => {
                if (
                    localStorage.id_role !== "8" &&
                    localStorage.id_role !== "6"
                ) {
                    next({ name: "login" });
                } else {
                    next();
                }
            },
            children: [
                {
                    name: "lista-autoescolas",
                    path: "lista",
                    component: lazyLoading("comercial/Index"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "ListaAlunos",
                    path: "alunos-cadastrados",
                    props: true,
                    component: lazyLoading("monitoria/alunos/Alunos"),
                },
                {
                    name: "RelatorioMonitoramento",
                    path: "relatorios+monitoramento",
                    component: lazyLoading("monitoria/relatorios/Relatorios"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "RelatorioFinanceiro",
                    path: "relatorios+financeiro",
                    props: true,
                    component: lazyLoading("financeiro/components/Relatorio"),
                },
            ],
        },
        {
            name: "Detran",
            path: "/detran/",
            component: AppLayoutDetran,
            beforeEnter: (to, from, next) => {
                if (localStorage.id_role !== "9") {
                    next({ name: "login" });
                } else {
                    next();
                }
            },
            children: [
                {
                    name: "Getran-listarAlunos",
                    path: "alunos",
                    component: lazyLoading("monitoria/alunos/Alunos"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "Getran-ListarAulasPraticas",
                    path: "aulas-praticas",
                    component: lazyLoading(
                        "monitoria/aulas-praticas/AulasPraticas"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "Getran-ListarTurmasTeoricas",
                    path: "turmas-teoricas",
                    component: lazyLoading(
                        "monitoria/turmas-teoricas/TurmasTeoricas"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "Getran-ListarAlertas",
                    path: "alertas",
                    component: lazyLoading("monitoria/alertas/Alertas"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "Getran-ListarInstrutores",
                    path: "instrutores",
                    component: lazyLoading("monitoria/instrutores/Instrutores"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "Getran-ListarVeiculos",
                    path: "veiculos",
                    component: lazyLoading("monitoria/veiculos/Veiculos"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                // {
                // 	name: 'Getran-ListarRelatorios',
                // 	path: 'relatorios',
                // 	component: lazyLoading('monitoria/relatorios/Relatorios'),
                // 	default: true,
                // 	meta: {
                // 		wikiLink: '#'
                // 	},
                // },
            ],
        },

        {
            name: "Monitoramento",
            path: "/monitoramento/",
            component: AppLayoutMonitoramento,
            beforeEnter: (to, from, next) => {
                if (["2", "8"].includes(localStorage.id_role)) {
                    next();
                } else {
                    next({ name: "login" });
                }
            },
            children: [
                {
                    name: "DashboardMonitoramento",
                    path: "dashboard",
                    component: lazyLoading("monitoria/dashboard/Dashboard"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    path: "praticas",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "MonEnvioAulasPraticas",
                            path: "envios-praticas",
                            component: lazyLoading("praticas/EnvioAulas/EnvioAulas"),
                            default: true,
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "ListarAulasPraticas",
                            path: "aulas-praticas",
                            component: lazyLoading(
                                "monitoria/aulas-praticas/AulasPraticas"
                            ),
                            default: true,
                            meta: {
                                wikiLink: "#",
                            },
                        }],
                },
                // {
                // 	name: 'VisualizarEditarAulaPratica',
                // 	path: 'aulas-praticas/autoescola/:schema/id/:id',
                // 	component: lazyLoading('monitoria/aulas-praticas/aula-pratica/AulaPratica'),
                // 	default: true,
                // 	props: true,
                // 	meta: {
                // 		wikiLink: '#'
                // 	},
                // },
                {
                    name: "ListarTurmasTeoricas",
                    path: "turmas-teoricas",
                    component: lazyLoading(
                        "monitoria/turmas-teoricas/TurmasTeoricas"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "ListarAulasVirtuais",
                    path: "aulas-virtuais",
                    component: lazyLoading(
                        "monitoria/aulas-teoricas/MonitorarVirtual"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "abrir-sala",
                    path: "salamonitoramento/:schema/:id",
                    component: lazyLoading(
                        "monitoria/aulas-teoricas/SalaMonitoramento"
                    ),
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "abrir-presenciais",
                    path: "salapresenciais/:schema/:id",
                    component: lazyLoading(
                        "monitoria/aulas-teoricas/SalaPresenciais"
                    ),
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "ListarAlunos",
                    path: "alunos",
                    component: lazyLoading("monitoria/alunos/Alunos"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "FeedAluno",
                    path: "feed-alunos",
                    component: lazyLoading("feed/Feed"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "ListarInstrutores",
                    path: "instrutores",
                    component: lazyLoading("monitoria/instrutores/Instrutores"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "ListarAulasPresenciais",
                    path: "aulas-presenciais",
                    component: lazyLoading(
                        "monitoria/aulas-teoricas/MonitorarPresenciais"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "ListarVeiculos",
                    path: "veiculos",
                    component: lazyLoading("monitoria/veiculos/Veiculos"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "ListarSalas",
                    path: "salas",
                    component: lazyLoading("monitoria/salas/Salas"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "Avisos",
                    path: "avisos",
                    component: lazyLoading("monitoria/avisos/Avisos"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "TelegramDashboard",
                    path: "avisos/telegram-dashboard",
                    component: () => import('@/views/avisos/TelegramDashboard.vue'),
                    default: true,
                    meta: {
                        wikiLink: "#",
                        requiresAuth: true,
                        requiresFunction: [1, 2] // id_role = 1 (admin) ou 2 (monitor)
                    },
                },
                {
                    name: "ListarRelatorios",
                    path: "relatorios",
                    component: lazyLoading("monitoria/relatorios/Relatorios"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "LogsMinimizacao",
                    path: "logs/minimizacao",
                    component: lazyLoading(
                        "monitoria/relatorios/logs/LogMinimizacao"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "LogsAgendamento",
                    path: "log/agendamento",
                    component: lazyLoading(
                        "monitoria/relatorios/logs/LogAgendamento"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "LogsApiCandidatoPratico",
                    path: "log/api-candidato-pratico",
                    component: lazyLoading(
                        "monitoria/relatorios/logs/LogApiCandidatoPratico"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "ConfiguracaoAdm",
                    path: "conf/gerenciamento",
                    component: lazyLoading(
                        "monitoria/configuracoes/Gerenciamento"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "auditoria-aulas",
                    path: "auditoria/aulas",
                    component: lazyLoading(
                        "auditoria/Aulas"
                    ),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
            ],
        },
        {
            name: "Stream",
            path: "/ead/",
            component: AppLayoutEad,
            children: [
                {
                    name: "indexStream",
                    path: ":link",
                    component: lazyLoading("ead/index"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "mobileStream",
                    path: ":link/:token/:agrupamento",
                    component: lazyLoading("ead/index"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
            ],
        },
        {
            name: "Admin",
            path: "/admin",
            component: AppLayout,
            beforeEnter: (to, from, next) => {
                if (
                    localStorage.id_role == "1" ||
                    localStorage.id_role == "2" ||
                    localStorage.id_role == "5" ||
                    (localStorage.id_role == 3 &&
                        (to.name == "listagem-turmas" ||
                            to.name == "dashboard"))
                ) {
                    next();
                } else {
                    next({ name: "login" });
                }
            },
            children: [
                {
                    name: "transactions",
                    path: "transacoes",
                    props: true,
                    component: lazyLoading(
                        "credito/Transactions"
                    ),
                },
                {
                    name: "buscar-cobranca-admin",
                    path: "cobrancas",
                    props: true,
                    component: lazyLoading(
                        "financeiro/CobrancasExtras"
                    ),
                },
                {
                    name: "notifications",
                    path: "notificacoes",
                    component: lazyLoading("notifications/Notifications"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "changelog",
                    path: "notificacoes/changelog",
                    component: lazyLoading("notifications/Changelog"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "dashboard",
                    path: "dashboard",
                    component: lazyLoading("dashboard/Dashboard"),
                    default: true,
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "admin-relatorio-aulas-por-aluno",
                    path: "relatorios/aulas-por-aluno",
                    component: lazyLoading("relatorios/RelatorioAulasPorAluno"),
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "admin-lista-de-alunos-por-periodo",
                    path: "relatorios/lista-de-alunos-por-periodo",
                    component: lazyLoading(
                        "relatorios/RelatorioListaAlunosPorPeriodo"
                    ),
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "admin-relatorio-aulas-praticas-realizadas",
                    path: "relatorios/relatorio-aulas-praticas-realizadas",
                    component: lazyLoading(
                        "relatorios/RelatorioAulasPraticasRealizadas"
                    ),
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "admin-carga-horaria-aulas-praticas-por-aluno",
                    path: "relatorios/carga-horaria-aulas-praticas-por-aluno",
                    component: lazyLoading(
                        "relatorios/RelatorioCargaHorariaAulasPraticasPorAluno"
                    ),
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "admin-relatorios",
                    path: "relatorios/admin",
                    component: lazyLoading(
                        "relatorios/RelatorioAdministrativo"
                    ),
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    name: "presenca",
                    path: "presenca",
                    component: lazyLoading("presenca/FormPresenca"),
                    meta: {
                        wikiLink: "#",
                    },
                },
                // {
                //   name: 'eadAluno',
                //   path: 'eadAluno',
                //   component: lazyLoading('ead/eadAluno'),
                //   meta: {
                //     wikiLink: '#'
                //   }
                // },
                {
                    name: "eadInstrutor",
                    path: "eadInstrutor",
                    component: lazyLoading("ead/eadInstrutor"),
                    meta: {
                        wikiLink: "#",
                    },
                },
                {
                    path: "usuarios",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "listagem-usuarios",
                            path: "",
                            component: lazyLoading("usuarios/ListagemUsuarios"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "novo-usuario",
                            path: "novo",
                            component: lazyLoading("usuarios/FormUsuario"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "editar-usuario",
                            path: "editar/:idUsuario",
                            component: lazyLoading("usuarios/FormUsuario"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "permissoes",
                            path: "permissoes",
                            component: lazyLoading("usuarios/Permissoes"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "veiculos",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "listagem-veiculos",
                            path: "",
                            component: lazyLoading("veiculos/ListagemVeiculos"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "novo-veiculo",
                            path: "novo",
                            component: lazyLoading(
                                "veiculos/FormVeiculoCadastro"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "editar-veiculo",
                            path: "editar/:idVeiculo",
                            component: lazyLoading("veiculos/FormVeiculo"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "instrutores",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "listagem-instrutores",
                            path: "",
                            component: lazyLoading(
                                "instrutores/ListagemInstrutores"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "dash-instrutor",
                            path: "dashboard",
                            component: lazyLoading("instrutores/DashInstrutor"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "novo-instrutor",
                            path: "novo",
                            component: lazyLoading(
                                "instrutores/FormInstrutorCadastro"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "editar-instrutor",
                            path: "editar/:idInstrutor",
                            component: lazyLoading(
                                "instrutores/FormInstrutorEdicao"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "alunos",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "listagem-alunos",
                            path: "",
                            component: lazyLoading("alunos/ListagemAlunos"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "listagem-pacientes",
                            path: "pacientes",
                            component: lazyLoading("alunos/ListagemPacientes"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "novo-aluno",
                            path: "novo",
                            component: lazyLoading("alunos/FormAlunoCadastro"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "emissao-ladv",
                            path: "ladv/:idAluno?",
                            component: lazyLoading("alunos/ladv/EmissaoLadv"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "novo-aluno-basic",
                            path: "basico",
                            component: lazyLoading("alunos/FormAlunoBasic"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "novo-aluno-psico",
                            path: "psicotecnico",
                            component: lazyLoading("alunos/FormPsicotecnico"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "editar-aluno",
                            path: "editar/:idAluno",
                            component: lazyLoading("alunos/FormAlunoEdicao"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "editar-paciente",
                            path: "editar/paciente/:idPaciente",
                            component: lazyLoading(
                                "alunos/FormPsicotecnicoEdicao"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "situacao-aluno",
                            path: "situacao",
                            component: lazyLoading("alunos/AlunoSituacao"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "alunos-reposicao",
                            path: "alunos/reposicao",
                            component: lazyLoading("alunos/AlunosReposicao"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "FeedAlunos",
                            path: "feed",
                            component: lazyLoading("feed/Feed"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "config",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "configuracoes",
                            path: "",
                            component: lazyLoading(
                                "configuracoes/Configuracoes"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "salas",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "listagem-salas",
                            path: "",
                            component: lazyLoading("salas/ListagemSalas"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "nova-sala",
                            path: "nova",
                            component: lazyLoading("salas/SalasCadastro"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "editar-sala",
                            path: "editar/:idSala",
                            component: lazyLoading("salas/SalasEdicao"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "cameras",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "listagem-cameras",
                            path: "",
                            component: lazyLoading("cams/ListagemCams"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "nova-cam",
                            path: "nova",
                            component: lazyLoading("cams/CamsCadastro"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "editar-camera",
                            path: "editar/:idCam",
                            component: lazyLoading("cams/CamsEdicao"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "turmas",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "listagem-turmas",
                            path: "",
                            component: lazyLoading("turmas/ListagemTurmas"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "cadastro-turma",
                            path: "nova",
                            component: lazyLoading("turmas/FormTurmaCadastro"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "nova-turma",
                            path: "nova",
                            component: lazyLoading("turmas/FormTurmaCadastro"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "aulas-reposicao",
                            path: "reposicao",
                            component: lazyLoading("turmas/Reposicao"),
                        },
                        {
                            name: "editar-turma",
                            path: "editar/:idTurma",
                            component: lazyLoading("turmas/FormTurmaEdicao"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "aula-teorica",
                            path: "aula-teorica/:idTurma",
                            component: lazyLoading("turmas/FormAulaTeorica"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "aulas-presenciais",
                            path: "aulas-presenciais",
                            component: lazyLoading("turmas/AulasPresenciais"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "agendamento",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "agendar-pratica",
                            path: "agendar",
                            component: lazyLoading(
                                "agendamento/AgendarPratica"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "aulas-agenda",
                            path: "agenda",
                            component: lazyLoading("agendamento/Agenda"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "iniciar-processo",
                            path: "processo/pratica",
                            component: lazyLoading(
                                "agendamento/IniciarProcesso"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "processo-index",
                            path: "processo/index",
                            component: lazyLoading("agendamento/Index"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "perimetro-index",
                            path: "perimetro/cadastro",
                            component: lazyLoading("perimetro/Index"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "processo-agendamento",
                            path: "processo/consulta",
                            component: lazyLoading(
                                "agendamento/AgendamentoConsulta"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "aulas-agendadas",
                            path: "agendadas",
                            component: lazyLoading(
                                "agendamento/AulasAgendadas"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "aulas-realizadas",
                            path: "realizadas",
                            component: lazyLoading(
                                "agendamento/AulasRealizadas"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "planos-praticos",
                            path: "planos-praticos",
                            component: lazyLoading(
                                "agendamento/PlanosPraticos"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "monitoramento",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "monitoramento-pratica",
                            path: "pratica",
                            component: lazyLoading(
                                "monitoramento/MonitorarPratica"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "monitoramento-teorica",
                            path: "teorica",
                            component: lazyLoading(
                                "monitoramento/MonitorarTeorica"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "monitoramento-virtual",
                            path: "virtual",
                            component: lazyLoading(
                                "monitoramento/MonitorarVirtual"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "ver-sala",
                            path: "monitorar/sala",
                            component: lazyLoading("monitoramento/Sala"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "ver-sala-max",
                            path: "monitorar/sala/max",
                            component: lazyLoading("monitoramento/SalaMaior"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "ver-sala-teorica",
                            path: "monitorar/sala/teorica",
                            component: lazyLoading("monitoramento/SalaTeorica"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "upload-foto-teorica",
                            path: "upload",
                            component: lazyLoading("monitoramento/UploadFotos"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "relatorio-monitoramento",
                            path: "relatorio-monitoramento",
                            component: lazyLoading(
                                "monitoramento/RelatorioMonitoramento"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "alertas",
                            path: "alertas",
                            component: lazyLoading("monitoramento/Alertas"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "status-cameras",
                            path: "status-cameras",
                            component: lazyLoading(
                                "monitoramento/StatusCameras"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "fotos-teoricas",
                            path: "fotos-teoricas",
                            component: lazyLoading(
                                "monitoramento/VerificarFotos"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "faturas",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "faturas-index",
                            path: "index",
                            component: lazyLoading("faturas/Index"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "relatorio",
                            path: "relatorio",
                            component: lazyLoading("faturas/Relatorio"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "faturas-praticas",
                            path: "faturas-praticas",
                            component: lazyLoading("faturas/FaturasPraticas"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "faturas-teoricas",
                            path: "faturas-teoricas",
                            component: lazyLoading("faturas/FaturasTeoricas"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "importarFaturas",
                            path: "importar",
                            component: lazyLoading(
                                "faturas/import-faturas/ImportFaturas"
                            ),
                        },
                    ],
                },
                {
                    path: "relatorios",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "acoes-usuarios",
                            path: "acoes-usuarios",
                            component: lazyLoading(
                                "relatorios/RelatorioAcoesUsuarios"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "faturamento",
                            path: "faturamento",
                            component: lazyLoading(
                                "relatorios/RelatorioFaturamento"
                            ),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                        {
                            name: "carga-horaria-teorica",
                            path: "carga-horaria-teorica",
                            component: lazyLoading(
                                "monitoria/aulas-teoricas/CargaHorariaTeorica"
                            ),
                        },
                    ],
                },
                {
                    path: "relatorios",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "geral",
                            path: "geral",
                            component: lazyLoading("relatorios/RelatorioGeral"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "cfc",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "cfc",
                            path: "cfc",
                            component: lazyLoading("autoescola/CFCs"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
                {
                    path: "cfc/novo",
                    component: EmptyParentComponent,
                    children: [
                        {
                            name: "cfc-novo",
                            path: "cfc-novo",
                            component: lazyLoading("autoescola/CadastroDetran"),
                            meta: {
                                wikiLink: "#",
                            },
                        },
                    ],
                },
            ],
        },
    ],
});

// Guard para verificar permissões de função
router.beforeEach((to, from, next) => {
    // Verifica se a rota requer uma função específica
    if (to.meta && to.meta.requiresFunction) {
        const requiredFunctions = Array.isArray(to.meta.requiresFunction)
            ? to.meta.requiresFunction
            : [to.meta.requiresFunction];

        // Obtém dados do usuário
        const user = JSON.parse(localStorage.getItem('usuario') || '{}');
        const userFunction = user.id_funcao_usuario || user.id_role;

        if (!requiredFunctions.includes(userFunction)) {
            // Usuário não tem a função necessária
            console.warn(`Acesso negado: usuário com função ${userFunction}, requeridas funções ${requiredFunctions.join(', ')}`);

            // Redireciona para dashboard ou página apropriada
            next('/dashboard');
            return;
        }
    }

    next();
});

export default router;
